/**
 * AccessLogBadges - Badge sub-components for AccessLogsPage
 *
 * ActionBadge, StatusBadge, DeviceIcon
 */
import React from 'react';
import { LogIn, LogOut, Key, Check, X, Monitor, Smartphone } from 'lucide-react';

export const ActionBadge: React.FC<{ acao: string }> = ({ acao }) => {
  const config = {
    LOGIN: { icon: LogIn, color: 'text-green-700 dark:text-green-400', bg: 'bg-green-100 dark:bg-green-900/30', label: 'Login' },
    LOGOUT: { icon: LogOut, color: 'text-yellow-700 dark:text-yellow-400', bg: 'bg-yellow-100 dark:bg-yellow-900/30', label: 'Logout' },
    REFRESH_TOKEN: { icon: Key, color: 'text-blue-700 dark:text-blue-400', bg: 'bg-blue-100 dark:bg-blue-900/30', label: 'Refresh' },
  }[acao] || { icon: Key, color: 'text-gray-700 dark:text-gray-400', bg: 'bg-gray-100 dark:bg-gray-900/30', label: acao };

  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${config.bg} ${config.color}`}>
      <Icon size={12} />
      {config.label}
    </span>
  );
};

export const StatusBadge: React.FC<{ sucesso: boolean }> = ({ sucesso }) => {
  if (sucesso) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400">
        <Check size={12} />
        Sucesso
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400">
      <X size={12} />
      Falha
    </span>
  );
};

export const DeviceIcon: React.FC<{ deviceType?: string }> = ({ deviceType }) => {
  if (deviceType === 'Mobile') {
    return <Smartphone size={14} className="text-gray-500 dark:text-gray-400" />;
  }
  return <Monitor size={14} className="text-gray-500 dark:text-gray-400" />;
};
